import translationBg from './locales/bg/translation.json';
import translationCz from './locales/cz/translation.json';
import translationDa from './locales/da/translation.json';
import translationDe from './locales/de/translation.json';
import translationEl from './locales/el/translation.json';
import translationEnAu from './locales/en-AU/translation.json';
import translationEnGb from './locales/en-GB/translation.json';
import translationEnUs from './locales/en-US/translation.json';
import translationEs from './locales/es/translation.json';
import translationEsLa from './locales/es-LA/translation.json';
import translationEsMx from './locales/es-MX/translation.json';
import translationEt from './locales/et/translation.json';
import translationFr from './locales/fr/translation.json';
import translationHu from './locales/hu/translation.json';
import translationIt from './locales/it/translation.json';
import translationJa from './locales/ja/translation.json';
import translationNb from './locales/nb/translation.json';
import translationNl from './locales/nl/translation.json';
import translationPl from './locales/pl/translation.json';
import translationPt from './locales/pt/translation.json';
import translationPtBr from './locales/pt-BR/translation.json';
import translationRo from './locales/ro/translation.json';
import translationRu from './locales/ru/translation.json';
import translationSk from './locales/sk/translation.json';
import translationSv from './locales/sv/translation.json';
import translationZh from './locales/zh/translation.json';
import translationZhCn from './locales/zh-CN/translation.json';
import Config from './config';
import { buildI18n, ILocaleOptions } from '@incentivegames/ig-frontend-common/lib/utilities/i18n';

const languageConfig: ILocaleOptions = {
  resources: {
    bg: {
      translations: translationBg,
    },
    cz: {
      translations: translationCz,
    },
    da: {
      translations: translationDa,
    },
    de: {
      translations: translationDe,
    },
    el: {
      translations: translationEl,
    },
    'en-AU': {
      translations: translationEnAu,
    },
    'en-GB': {
      translations: translationEnGb,
    },
    'en-US': {
      translations: translationEnUs,
    },
    es: {
      translations: translationEs,
    },
    'es-LA': {
      translations: translationEsLa,
    },
    'es-MX': {
      translations: translationEsMx,
    },
    et: {
      translations: translationEt,
    },
    fr: {
      translations: translationFr,
    },
    hu: {
      translations: translationHu,
    },
    it: {
      translations: translationIt,
    },
    ja: {
      translations: translationJa,
    },
    nb: {
      translations: translationNb,
    },
    nl: {
      translations: translationNl,
    },
    pl: {
      translations: translationPl,
    },
    pt: {
      translations: translationPt,
    },
    'pt-BR': {
      translations: translationPtBr,
    },
    ro: {
      translations: translationRo,
    },
    ru: {
      translations: translationRu,
    },
    sk: {
      translations: translationSk,
    },
    sv: {
      translations: translationSv,
    },
    zh: {
      translations: translationZh,
    },
    'zh-CN': {
      translations: translationZhCn,
    },
  },

  language: Config.settings.defaultLanguage,
  fallback: Config.settings.fallbackLanguage,
};

export default buildI18n(languageConfig);
